// Simple inline toast notifications — replaces all browser alert() / confirm() calls.
import { useState, useCallback } from 'react';

export interface Toast {
  id:      string;
  ok:      boolean;   // true = success (green), false = error (red)
  message: string;
}

export function useToast(autoDismissMs = 4000) {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const push = useCallback((message: string, ok = true) => {
    const id = crypto.randomUUID();
    setToasts((p) => [...p, { id, ok, message }]);
    if (autoDismissMs > 0) {
      setTimeout(() => setToasts((p) => p.filter((t) => t.id !== id)), autoDismissMs);
    }
  }, [autoDismissMs]);

  const dismiss = useCallback((id: string) => {
    setToasts((p) => p.filter((t) => t.id !== id));
  }, []);

  return { toasts, push, dismiss };
}
